module.exports = __webpack_public_path__ + "static/media/xchange-header.1e4655c0.png";